import { render } from "./ProductDataTopSection.vue?vue&type=template&id=05aa9166&scoped=true"
import script from "./ProductDataTopSection.vue?vue&type=script&lang=js"
export * from "./ProductDataTopSection.vue?vue&type=script&lang=js"

import "./ProductDataTopSection.vue?vue&type=style&index=0&id=05aa9166&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa9166"]])

export default __exports__